import Immutable from 'immutable';

export const State = Immutable.fromJS({
	// storeIdList: null,
 //  stores: {},
 //  selectedStoreId: ''
});
